import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'

import {
  Button,
  Checkbox,
  Icon,
  InputDropdown,
  NewTable,
  Section,
} from '@vallourec-ui/vallourec-ui'
import { useTranslation } from 'react-i18next'

import { usePageTitle } from '../../hooks/usePageTitle'
import DataToEditSection from './_components/DataToEditSection'
import FilterSection from './_components/FilterSection'
import {
  ButtonContainer,
  Container,
  ContentContainer,
  Row,
  StyledButton,
  StyledTextButton,
} from './style'
import { PageProps, RemarkReport, Remark } from '@/@types/global'
import { useApp } from '@/stores/AppStore'
import DataToResult from './_components/DataToResult'

const SearchReport: React.FC<PageProps> = ({ title, subtitle }) => {
  const { t } = useTranslation()

  const { setIsLoading, setRemark } = useApp()
  const [site, setSite] = useState('')

  usePageTitle({ title, subtitle })

  useEffect(() => {
    const removeDuplicateRemarks = (items: RemarkReport[]) => {      
      items.forEach(item => {
        const uniqueRemarks: Remark[] = [];
        const seenRemarks = new Set();
        
        item.remarks.forEach((elemt) => {
          const remarkKey = `${elemt.line}-${elemt.remark}`;
          if (!seenRemarks.has(remarkKey)) {
            seenRemarks.add(remarkKey);
            uniqueRemarks.push(elemt);    
          }
        });
        
        item.remarks = uniqueRemarks;
      });
      
      return items;
    }
    
    const fetchConfigRemark = async () => {
      
  
      try {
        // const response = await getConfigRemark() as unknown as {items: RemarkReport[]}
        // const items = response && response.items ? removeDuplicateRemarks(response.items) : null;
        // setRemark(items ?? [])
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchConfigRemark()
  }, [setIsLoading])

  return (
    <Container>
      <FilterSection />
      <DataToEditSection />
      <DataToResult />
    </Container>
  )
}

export default SearchReport
